module.exports = __webpack_public_path__ + "img/notify2.9d57d63a.png";